// extracted by mini-css-extract-plugin
export default {"main":"Background_main__EaxNa","image":"Background_image__gCPzO","image_top":"Background_image_top__DagT9","image_bottom":"Background_image_bottom__D3ZtS"};